import React, {useState} from "react";
import Styles from './UnwantedActivity/UnwantedActivity.module.scss'
import {CircularProgressbar} from "react-circular-progressbar";
import {showDuration} from "../../../../../util/util";
import Button from "../../../../Componnets/mainButton/Button";
import IsolatedViewPopup from "../IsolatedViewPopup";

const UnwantedActivity = ({card}) => {
    const [showPopup, setShowPopup] = useState(false)

    const sequenceList = []
    if (card?.[0]) {
      sequenceList.push(card?.[0])
    }

    const handleTriggerShowPopup = () => {
      setShowPopup(!showPopup)
    }

    return (
        <div className="col-12 col-lg-6 col-xl-4">
            <div className={`d-flex justify-content-between ${Styles.card}`}>
                <div className={'relative'}>
                    <p className="f12 fw500 gray">Unwanted Activity</p>
                    <p className="f16 fw500 dark-gary-2" title={card[0]}>{card[0].substr(0,30)}</p>
                    <div className="d-flex mt-3">
                        <div className={Styles.progressCircle}>
                            <CircularProgressbar  value={card[1].percent_containin_cases} text={''}
                                                  styles={{
                                                      root: {},
                                                      // Customize the path, i.e. the "completed progress"
                                                      path: {
                                                          // Path color
                                                          // stroke: '#d6d6d6',
                                                          stroke: '#8a0fff',
                                                          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                                          strokeLinecap: 'butt',
                                                          // Customize transition animation
                                                          transition: 'stroke-dashoffset 0.5s ease 0s',
                                                          // Rotate the path
                                                          transform: 'rotate(0.0turn)',
                                                          transformOrigin: 'center center',
                                                          strokeWidth:10
                                                      },
                                                      // Customize the circle behind the path, i.e. the "total progress"
                                                      trail: {
                                                          // Trail color
                                                          stroke: '#d6d6d6',
                                                          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                                          // strokeLinecap: 'butt',
                                                          // Rotate the trail
                                                          // transform: 'rotate(0.25turn)',
                                                          // transformOrigin: 'center center',
                                                      },
                                                      // Rotation of path and trail, in number of turns (0-1)
                                                      rotation: 0,

                                                      // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                                      strokeLinecap: 'butt',

                                                      // How long animation takes to go from one percentage to another, in seconds
                                                      pathTransitionDuration: 0.5,
                                                  }}

                            />
                        </div>
                        <div className={Styles.casesBox}>
                            <p className="f12 fw500 gray">Cases</p>
                            <div className={`d-flex`}>
                                <p className={`dark-gary-2 f14 fw900`}>{card[1].containing_cases_count}</p>
                                <div className={Styles.miniLine}></div>
                                <p className="dark-gary-2 f14 fw900">{(card[1].percent_containin_cases).toFixed(2)}%</p>
                            </div>
                        </div>
                    </div>
                    <div style={{width: 210, marginTop: 16}}>
                      <Button
                        type={showPopup && "outlined"}
                        color={showPopup && "primary"}
                        size={"medium"}
                        hoverOutlined
                        block
                        rightArrow
                        onClick={handleTriggerShowPopup}
                      >
                        Make an Isolated View
                      </Button>
                    </div>
                    <IsolatedViewPopup show={showPopup} sequenceList={sequenceList} onTriggerShowPopup={handleTriggerShowPopup} />
                </div>
                <div className={Styles.rightBox}>
                    <p className={Styles.effectOn}>Effects on</p>
                    <p className="f12 fw400 gray mt-2">Throughput Time</p>
                    <p className="f14 fw600 dark-gary-2">{showDuration(card[1].containing_cases_median_time)}</p>
                    <p className="f12 fw400 gray mt-2 disable">Income</p>
                    <p className="f14 fw600 dark-gary-2 disable">5400 $</p>
                    <p className="f12 fw400 gray mt-2">Steps per case</p>
                    <p className="f14 fw600 dark-gary-2">{card[1].effect_on_steps} Steps</p>
                </div>
                {/*<svg  className={Styles.border} width="1" height="187" viewBox="0 0 1 187" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                {/*    <line x1="0.5" y1="-2.18557e-08" x2="0.500008" y2="187" stroke="#E8EBFF" stroke-dasharray="7 7"/>*/}
                {/*</svg>*/}
            </div>
        </div>
    )
};

export default UnwantedActivity;
